module.exports = __webpack_public_path__ + "static/media/icn_basket_esculab.22abfd30.svg";